import type { SVGProps } from 'react';
const SvgLinkedin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2ZM9.552 16.145H7.527V9.628h2.025v6.517ZM8.527 8.828c-.64 0-1.053-.453-1.053-1.013 0-.572.426-1.012 1.08-1.012.652 0 1.052.44 1.065 1.012 0 .56-.413 1.013-1.092 1.013Zm8.42 7.317h-2.024v-3.612c0-.84-.294-1.411-1.026-1.411-.56 0-.892.386-1.039.758-.054.132-.067.32-.067.506v3.758h-2.026v-4.438c0-.813-.027-1.493-.054-2.079h1.76l.092.905h.041c.267-.425.92-1.052 2.013-1.052 1.332 0 2.33.893 2.33 2.812v3.853Z"
    />
  </svg>
);
export default SvgLinkedin;
